export enum CookiesEnum {
  TechnicalCookieKey = 'technicalCookiesAccepted',
  AnalyticCookieKey = 'analyticsCookiesAccepted',
  LoadedScripts = 'loadedScripts',
  DownloadAppDialogShown = 'downloadAppDialogShown',
}
